import { useState, useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import { formatArabicNumber } from '@/utils/numberUtils';

const SuggestionsModal = ({ isOpen, onClose, suggestions, onSelectSuggestion }) => {
  const modalRef = useRef(null);
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      closeButtonRef.current?.focus();
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleSuggestionClick = (suggestion) => {
    onSelectSuggestion(suggestion);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content suggestions-modal" ref={modalRef} role="dialog" aria-modal="true" aria-labelledby="suggestions-title">
        <div className="modal-header">
          <h2 id="suggestions-title" className="modal-title">اقتراحات للدفع المختلط (جديد مع قديم)</h2>
          <button 
            ref={closeButtonRef}
            className="modal-close" 
            onClick={onClose}
            aria-label="إغلاق"
          >
            <X size={24} />
          </button>
        </div>
        
        <div className="modal-body">
          {suggestions.length === 0 ? (
            <p className="suggestions-empty">أدخل المبلغ المطلوب أولاً</p>
          ) : (
            <div className="suggestions-table">
              <div className="suggestions-header">
                <span>عملة جديدة</span>
                <span>عملة قديمة</span>
                <span></span>
              </div>
              {suggestions.map((suggestion) => (
                <div
                  key={suggestion.key}
                  className="suggestion-row"
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  <span className="suggestion-value num" dir="ltr">
                    {suggestion.newAmount > 0 
                      ? formatArabicNumber(suggestion.newAmount) 
                      : '—'}
                  </span>
                  <span className="suggestion-value num" dir="ltr">
                    {suggestion.oldAmount > 0 
                      ? formatArabicNumber(suggestion.oldAmount) 
                      : '—'}
                  </span>
                  <button className="suggestion-use-btn" type="button">
                    استخدم
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuggestionsModal;
